import { cva } from 'class-variance-authority'

export const selectTriggerVariants = cva(
  // Base trigger styles aligned with Input/Button patterns
  'flex w-full items-center justify-between rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs outline-none transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      size: {
        // h-9 matches Input default; keep text sizes consistent with other components
        default: 'h-9',
        sm: 'h-8 text-xs',
        xs: 'h-7 text-xs',
        lg: 'h-10',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)
